import { useNavigate } from 'react-router-dom';
import { useQuery } from 'react-query';
import { useState } from 'react';
import { Switch } from 'antd';

import { getUser } from '../../../../service/user';

import UserImage from '../../../../components/UserImage/UserImage';
import { ClubUser } from '../../../../models/clubUser';
import styles from './RegisterAttendanceItem.module.scss';

interface PropsAttendanceSumary {
  member: ClubUser
}

type Props = Pick< PropsAttendanceSumary, 'member'> 
& {
  onAttendanceChange: (userId: number, wasInAttendance: boolean) => void
};

const RegisterAttendanceItem = ({ member, onAttendanceChange }: Props) => {

  const navigate = useNavigate();
  const userId = member.userId;
  const [wasInAttendance, setWasInAttendance] = useState(false);

  const {data:user, isFetching} = useQuery(
    ['user', userId],
    () => getUser(userId),
    {refetchOnMount: 'always', staleTime: 0, refetchOnWindowFocus: false},
  );

  const onChange = (checked: boolean) => {
    setWasInAttendance(checked);
    onAttendanceChange(userId, checked);
  };

  if (isFetching) return null;

  return (
    <div className={styles.item} key={"register-attendance-member_"+userId}>
      <div className={styles.userContainer} onClick={() => navigate(`/user/${user.id}`)}>
          <UserImage style={styles.circleUser} path={user?.pathPhoto} name={user?.fullname}/>
          <span>{user?.fullname}</span>
      </div>
      <Switch onChange={onChange} checked={wasInAttendance} />
    </div>
  )
}

export default RegisterAttendanceItem;